'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasGivenConsentToProcess = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasGivenConsentToProcess = exports.hasGivenConsentToProcess = (0, _getIn2.default)(_keyPaths.HAS_GIVEN_CONSENT_TO_PROCESS);


//////////////////
// WEBPACK FOOTER
// ./js/widget-data/operators/hasGivenConsentToProcess.js
// module id = 904
// module chunks = 2 3